import { Outlet, Navigate } from "react-router-dom";

const AuthenticationRoutes = () => {
  let role = localStorage.getItem("Role");
  if (
    role === "Shipper" ||
    role === "ShipperUser" ||
    role === "oneTimeShipper"
  ) {
    return <Navigate to="/" />;
  } else if (role === "Carrier") {
    return <Navigate to="/create-zone" />;
  } else if (role === "Admin") {
    return <Navigate to="/Users" />;
  } else {
    return (
      <>
        <Outlet />
      </>
    );
  }
};

export default AuthenticationRoutes;
